import React from "react";
import PackValidationProvider
    from "@/pages/takeoff/layouts/validation/layouts/details/context/pack-validation-provider.tsx";
import ViewerItemsColorProvider from "@/services/context/viewer/items-color/viewer-items-color-provider.tsx";
import ValidationDetails from "@/pages/takeoff/layouts/validation/layouts/details/index.tsx";
import ViewerItemsSelectionProvider
    from "@/services/context/viewer/items-selection/viewer-items-selection-provider.tsx";
import useProjectFormNavigationContext from "@/pages/takeoff/context/project-form-navigation/use-project-form-navigation-context.ts";

const ValidationLayout: React.FC = () => {
    const { getParam } = useProjectFormNavigationContext();
    
    const storeyId = getParam('storeyId');

    return (
        <>
            {storeyId &&
                <ViewerItemsSelectionProvider>
                    <PackValidationProvider>
                        <ViewerItemsColorProvider>
                            <ValidationDetails storeyId={storeyId}/>
                        </ViewerItemsColorProvider>
                    </PackValidationProvider>
                </ViewerItemsSelectionProvider>
            }
        </>
    )
}

export default ValidationLayout;